import React, { useEffect, useMemo } from 'react'
import DateRange from './DateRange'
import { withTranslation } from 'react-i18next'
import BtnSelection from './BtnSelection'
import { FormProvider, useForm } from 'react-hook-form'
import { apiRequest } from 'store/Misc/apiRequest'
import dayjs from 'dayjs'
import useSWR from 'swr'
import { toast } from 'react-toastify'


const revalidate = async (payload, endpoint) => {
  try {
    const res = await apiRequest({
      method: 'post',
      url: `dashboard/line-graphs/${endpoint}`,
      payload
    })
    return res?.data
  } catch (error) {
    toast.error(error)
  }
}

export default withTranslation()(function Header({ t, dataView, getRange, getChartData = () => null, tab }) {
  const { data: branches } = useSWR('merchants/branches')
  const { data: pos } = useSWR('pos?page=1&page-size=100')
  const { data: defaults } = useSWR('merchants/me')

  const method = useForm({ mode: 'all', })
  const { watch, reset } = method

  let range = watch('date_range'),
    branch_id = watch('branch_id'),
    pos_id = watch('pos_id'),
    merchant_id = defaults?.data?.id

  useEffect(() => {
    reset({
      branch_id: defaults?.data?.main_branch?.id
    })
  }, [defaults?.data?.main_branch?.id, reset, merchant_id])

  const endpoint = useMemo(() => ['revenues', 'loyalty-metrics', 'ratings'][tab], [tab])

  useEffect(() => {
    const graph_data = async () => {
      switch (dataView) {
        case 'general':
          if (range && range[0] && range[1]) {
            return revalidate({
              mode: 'general',
              start: dayjs(range[0]).format('YYYY-MM-DD'),
              end: dayjs(range[1]).format('YYYY-MM-DD')
            }, endpoint)
          } else {
            return revalidate({
              mode: 'general'
            }, endpoint)
          }

        case 'branch':
          if (range && branch_id) {
            return revalidate({
              mode: 'branch',
              start: dayjs(range[0]).format('YYYY-MM-DD'),
              end: dayjs(range[1]).format('YYYY-MM-DD'),
              options: { branch_id, merchant_id }

            }, endpoint)
          } else {
            return revalidate({
              mode: 'branch',
              options: { branch_id, merchant_id },
            }, endpoint)
          }

        case 'pos':
          if (range && branch_id && pos_id) {
            return revalidate({
              mode: 'branch',
              start: dayjs(range[0]).format('YYYY-MM-DD'),
              end: dayjs(range[1]).format('YYYY-MM-DD'),
              options: { branch_id, merchant_id, pos_id }
            }, endpoint)
          } else if (branch_id && pos_id) {
            return revalidate({
              mode: 'pos',
              options: { branch_id, merchant_id, pos_id },
              start: dayjs(range[0]).format('YYYY-MM-DD'),
              end: dayjs(range[1]).format('YYYY-MM-DD')
            }, endpoint)
          } else {
            return revalidate({
              mode: 'pos',
              options: { branch_id, merchant_id }
            }, endpoint)
          }

        default: return null
      }
    }

    (async () => {
      const res = await graph_data()
      console.log(res)
      getChartData(res)
    })()
  }, [range, branch_id, pos_id, merchant_id, dataView, endpoint]);
  // range, branch_id, pos_id, merchant_id, getChartData, dataView, endpoint


  return (
    <>
      <FormProvider {...method}>
        <div className="items-center !justify-end flex" >
          {
            dataView === 'pos' || dataView === 'branch' ? (
              <div className={`w-full col-span-4 ${dataView === 'branch' ? 'mr-4' : ''}`}>
                <BtnSelection name="branch_id" options={branches?.data.data} label="Select branch" />
              </div>
            ) : null
          }
          {
            dataView === 'pos' ? (
              <div className=" md:mx-4 col-span-4">
                <BtnSelection className="" name="pos_id" options={pos?.data.data} label="Select POS" />
              </div>
            ) : null
          }
          <DateRange name="date_range" className={``} getRange={getRange} />
        </div>
        {/* </div> */}
      </FormProvider></>
  )
})
